import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Border Crossings API
 */
export const wsdotBorderCrossingsApiMeta: ApiMeta = {
  name: "wsdot-border-crossings",
  baseUrl:
    "https://wsdot.wa.gov/Traffic/api/BorderCrossings/BorderCrossingsREST.svc",
};
